import { FC } from "react";
import { AppointmentRequestOpen } from "@/components/appointmentRequest/appointmentRequestOpen";
import RestrictedPage from "@/consumer/restrictedPage";

interface Props {
  subdomain: string;
}

const AppointmentRequest: FC<Props> = ({ subdomain }) => {
  return (
    <RestrictedPage permissionRequired="frontend_view_user_appointment">
      <AppointmentRequestOpen subdomain={subdomain} />
    </RestrictedPage>
  );
};

export default AppointmentRequest;
